import { Helmet } from 'react-helmet';
import SecNavbar from '../../components/light/services-details/SecNavbar';
import Footer from '../../components/light/creative-agency/Footer';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import AiExploreBar from '../../components/light/ai/AiExploreBar';
import AiVideoCard from '../../components/light/ai/AiVideoCard';
import '../../components/light/ai/aiStyles.css';

const videos = [
  'drinks.mp4',
  'clothing.mp4',
  'amrut-atta.mp4',
  'icecream2.mp4',
  'jewellery.mp4',
  'Farmhands.mp4',
  'Punjab-Demo.mp4',
  'nucc.mp4',
  'red-wine-soap-ugc.mp4',
  'gusbmps_Ai_Video.mp4',
  'greenelixirayurveda.mp4',
].map((fileName) => ({
  fileName,
  src: `/light/assets/ai/Videos/${fileName}`,
}));

export default function PageAiVideos() {
  return (
    <>
      <Helmet>
        <title>Aashway | AI Videos</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <Cursor />
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          <SecNavbar />
          <div id="smooth-content">
            <main className="main-bg">
              {/* Header section matching other service layouts */}
              <div
                className="header page-header bg-img section-padding"
                data-background="/light/assets/imgs/header/b5.jpg"
                data-overlay-dark="9"
                style={{ backgroundImage: 'url("/light/assets/imgs/header/b5.jpg")' }}
              >
                <div className="container pt-100">
                  <div className="text-center">
                    <h1 className="fz-100 text-u">AI Videos</h1>
                    <div className="mt-15">
                      <a href="/">Home</a>
                      <span className="padding-rl-20">|</span>
                      <a href="/light/page-ai">AI</a>
                      <span className="padding-rl-20">|</span>
                      <span className="main-color">Videos</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sub-navigation bar */}
              <div className="container mt-40">
                <AiExploreBar active="videos" />
              </div>

              {/* Gallery section */}
              <section className="ai-section-wrap pt-40">
                <div className="container">
                  <div className="ai-gallery">
                    {videos.map((v) => (
                      <AiVideoCard key={v.src} src={v.src} fileName={v.fileName} />
                    ))}
                  </div>
                </div>
              </section>
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}


